import { render } from "./DossierPaiement.vue?vue&type=template&id=5ce7a1ac&scoped=true"
import script from "./DossierPaiement.vue?vue&type=script&lang=js"
export * from "./DossierPaiement.vue?vue&type=script&lang=js"

import "./DossierPaiement.vue?vue&type=style&index=0&id=5ce7a1ac&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce7a1ac"]])

export default __exports__